var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-container position-fixed p-3",staticStyle:{"top":"1rem","right":"1rem","z-index":"1050"}},_vm._l((_vm.toasts),function(toast,index){return _c('Toast',{key:toast.id,attrs:{"type":toast.type,"message":toast.message,"duration":toast.duration},on:{"closed":function($event){return _vm.removeToast(index)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a6dbcc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToastContainer.vue
// module id = null
// module chunks = 